(function () {
  var D = document.documentElement, EASE = "translate .85s cubic-bezier(.65,0,.25,1)", FAST = "translate .55s cubic-bezier(.3,.7,.25,1)";
  function run() {
    if (!D.classList.contains("bf-on")) return;
    var s = document.querySelector("[data-bf-slide]"); if (!s || s._bf) return; s._bf = 1;
    var hero = s.closest(".hero"), ctr = hero.querySelector("[data-bf-ctr]"), pgs = ctr.querySelector("[data-bf-pgs]");
    var P = [].slice.call(s.querySelectorAll("[data-bf-unit]"));
    var heroEls = [].slice.call(hero.children).filter(function (e) { return e !== s && e !== ctr && !/^(SCRIPT|STYLE|TEMPLATE)$/.test(e.tagName); });
    var hold = (+s.dataset.hold || 7), show = (+s.dataset.show || 9);
    var still = matchMedia("(prefers-reduced-motion: reduce)").matches, mq = matchMedia("(max-width: 760px)");
    var U, si = 0, sx = null, sy = null, seen = {};
    var mot = D.getAttribute("data-hmotion") === "zoom_rise_parallax";
    function st(u, v) { if (mot && u.mk) u.mk.setAttribute("data-bfm", v); }
    /* his rule: hover / hold / focus pauses only once the visitor has seen every slide, so nobody freezes it before the deals */
    function all() { return U && U.every(function (u, i) { return seen[i]; }); }
    function pause() { if (all()) hero.classList.add("paused"); }
    hero.classList.add("bf-show");
    /* smooth arrows on PC: decode the deal photos before the first move (a lazy photo decoding mid slide made it choppy) */
    [].forEach.call(s.querySelectorAll("img"), function (im) { if (im.decode) im.decode().catch(function () {}); });
    function units() {
      var h = { els: heroEls, hero: 1, dur: hold, mk: hero };
      /* phone "one deal per slide" only */
      return (mq.matches && s.dataset.pl === "single") ? [h, { els: [P[0]], dur: show, mk: P[0] }, { els: [P[1]], dur: show, mk: P[1] }] : [h, { els: [s], dur: show, mk: s }];
    }
    /* translate only: a brightness filter on the full size hero photo repainted every frame and made the arrows feel slow */
    var quick = false;
    function put(u, x, dim, anim) {
      u.els.forEach(function (e) {
        e.style.transition = anim && !still ? (quick ? FAST : EASE) : "none";
        e.style.translate = x + "% 0";
      });
    }
    function live(u, on) {
      u.els.forEach(function (e) { if (on) e.removeAttribute("inert"); else e.setAttribute("inert", ""); });
    }
    function bars() {
      pgs.innerHTML = "";
      U.forEach(function (u, i) {
        var b = document.createElement("button"); b.type = "button"; b.setAttribute("data-bf-go", i);
        b.setAttribute("aria-label", i ? "Deal slide " + i : "Main slide");
        b.innerHTML = "<span>0" + (i + 1) + "</span><i></i>"; pgs.appendChild(b);
      });
    }
    function mark() {
      seen[si] = 1; if (all() && hero.matches(":hover")) hero.classList.add("paused");
      [].forEach.call(pgs.children, function (b, j) { b.classList.remove("on"); b.classList.toggle("done", j < si); });
      hero.style.setProperty("--dur", U[si].dur + "s");
      void pgs.offsetWidth; if (pgs.children[si]) pgs.children[si].classList.add("on");
    }
    /* stacking: the deals layer sits above the hero while a deal slide comes in, below it while the hero comes back in */
    function layer(toHero) { s.style.zIndex = toHero ? -3 : 3; }
    function to(i, back) {
      var n = (i + U.length) % U.length; if (n === si) return;
      var a = U[si], b = U[n];
      layer(back ? !!a.hero : !!b.hero); /* the slide that moves over the other one is the incoming one (the outgoing one when going back) */
      /* every other slide is parked off screen right, so only the two moving slides can show */
      U.forEach(function (u) { if (u !== a && u !== b) put(u, 100, false, false); });
      /* the incoming slide starts off screen on the right (or dimmed on the left when going back), then both move together */
      put(b, back ? -30 : 100, back, false);
      /* hero motion: the incoming slide starts hidden with its photo trailing, every other slide is parked */
      U.forEach(function (u) { if (u !== a && u !== b) st(u, "pre"); });
      /* going back onto the slide that is still parked on the left keeps its zoom running (no reset flash): it just glides in */
      var cont = mot && back && b.mk && b.mk.getAttribute("data-bfm") === "out";
      if (!cont) st(b, back ? "preb" : "pre");
      if (!a.hero && !b.hero) { a.els[0].style.zIndex = back ? 2 : 1; b.els[0].style.zIndex = back ? 1 : 2; }
      else P.forEach(function (e) { e.style.zIndex = e === b.els[0] ? 2 : 1; });
      void hero.offsetWidth;
      /* GPU layer only while moving (left on all the time it made the page shake); released when the move ends */
      var mv = a.els.concat(b.els); mv.forEach(function (e) { e.style.willChange = "translate"; });
      clearTimeout(s._wc); s._wc = setTimeout(function () { mv.forEach(function (e) { e.style.willChange = ""; }); }, 1100);
      hero.style.setProperty("--bfm-t", quick ? ".55s" : ".85s"); hero.style.setProperty("--bfm-e", quick ? "cubic-bezier(.3,.7,.25,1)" : "cubic-bezier(.65,0,.25,1)");
      put(b, 0, false, true); put(a, back ? 100 : -30, !back, true);
      st(b, cont ? "inb" : "in"); st(a, back ? "outb" : "out");
      live(a, false); live(b, true); si = n; mark();
    }
    function reset() {
      hero.removeAttribute("data-bfm"); s.removeAttribute("data-bfm"); P.forEach(function (e) { e.removeAttribute("data-bfm"); });
      U = units(); si = 0; seen = {}; layer(true);
      [s].concat(P, heroEls).forEach(function (e) { e.style.transition = "none"; e.style.translate = ""; e.style.zIndex = ""; });
      U.forEach(function (u, i) { if (mot) u.mk.style.setProperty("--bfm-d", (u.dur + 2) + "s"); st(u, i ? "pre" : "in"); });
      U.forEach(function (u, i) { if (i) { put(u, 100, false, false); live(u, false); } });
      live(U[0], true); bars(); mark();
    }
    hero.addEventListener("animationend", function (e) { if (e.animationName === "pg" && e.target.closest("[data-bf-pgs]")) to(si + 1); });
    ctr.addEventListener("click", function (e) {
      var b = e.target.closest("[data-bf-go]"); if (!b) return; quick = true; setTimeout(function () { quick = false; }, 0);
      var v = b.getAttribute("data-bf-go");
      if (v === "next") to(si + 1); else if (v === "prev") to(si - 1, 1); else to(+v, +v < si);
    });
    hero.addEventListener("keydown", function (e) { quick = true; setTimeout(function () { quick = false; }, 0); if (e.key === "ArrowRight") to(si + 1); if (e.key === "ArrowLeft") to(si - 1, 1); });
    hero.addEventListener("pointerenter", function (e) { if (e.pointerType === "mouse") pause(); });
    hero.addEventListener("pointerleave", function () { hero.classList.remove("paused"); });
    hero.addEventListener("pointerdown", function (e) { sx = e.clientX; sy = e.clientY; if (e.pointerType !== "mouse") pause(); });
    function up(e) {
      if (e.pointerType !== "mouse") hero.classList.remove("paused");
      if (sx !== null && Math.abs(e.clientX - sx) > 50 && Math.abs(e.clientX - sx) > Math.abs(e.clientY - sy)) {
        quick = true; if (e.clientX < sx) to(si + 1); else to(si - 1, 1); quick = false;
      }
      sx = null;
    }
    hero.addEventListener("pointerup", up); hero.addEventListener("pointercancel", up);
    hero.addEventListener("focusin", function () { pause(); });
    hero.addEventListener("focusout", function () { hero.classList.remove("paused"); });
    (mq.addEventListener ? mq.addEventListener("change", reset) : mq.addListener(reset));
    reset();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run); else run();
})();
